import { NavigationBar } from '@travelnest/hui';
import * as React from 'react';
import { IAction } from '../../../components/action/types';
import { Heading } from '../../../components/heading/Heading';
import { HelpLink } from '../../../components/help-link/HelpLink';
import { Loader } from '../../../components/loader/Loader';
import { NavTile } from '../../../components/nav-tile/NavTile';
import { Paragraph } from '../../../components/paragraph/Paragraph';

interface IActionDetailsProps {
	action: IAction | undefined;
	loading: boolean;
}

export const ActionDetailsComponent: React.FC<IActionDetailsProps> = ({ action, loading }) => {
	return (
		<div className="portal-wrapper">
			<NavigationBar title="Action" />
			{loading
				? <Loader loading />
				: !action?.details
					? null
					: (
						<div className="action-details__content" style={{ maxWidth: '50%' }}>
							<Heading type="B1">{action.title}</Heading>
							{action.details.info.map((info, i) => (
								<Paragraph key={i}>{info}</Paragraph>
							))}
							{action.details.path && <div className={`action-details__content-nav ${(!action.details.help && !action.details.helpLinks) && 'clean'}`}>
								{/* If path is an external link, i.e. (`http....` vs `/foo/bar`) then open link in new window,
						the action page should remain the same - hence setting the `to=` to the current url. */}
								{action.details.path.startsWith('http') ?
									<NavTile
										label={action.details.pathLabel}
										to={`/action/${action.type}/${action.consumer.id}`}
										onClick={() => window.open(action.details?.path, '_blank')} /> :
									<NavTile
										label={action.details.pathLabel}
										to={action.details.path} />
								}
							</div>}
							{(action.details.help || action.details.helpLinks) && <div className="action-details__content-help">
								<Heading type="B1">Need help?</Heading>
								{action.details.help && action.details.help.map((help, i) => (
									<Paragraph key={i}>{help}</Paragraph>
								))}
								{action.details.helpLinks && action.details.helpLinks.map((hl, i) => (
									<HelpLink key={i} to={hl.url} target={hl.target}>{hl.title}</HelpLink>
								))}
							</div>}
						</div>
					)}
		</div>
	);
};
